import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { ASSET_PANELS_KEYS, SEARCH_PANELS_KEYS } from '../../../constants/data';
import type { PanelsPristine } from './types';

const initialState: PanelsPristine = {};
ASSET_PANELS_KEYS.forEach((key) => {
  initialState[key] = true;
});

SEARCH_PANELS_KEYS.forEach((key) => {
  initialState[key] = true;
});

export const panelsPristineSlice = createSlice({
  name: 'panels_pristine',
  initialState,
  reducers: {
    setPanelPristineById: (state, action: PayloadAction<string>) => {
      state[action.payload] = true;
    },
    setPanelDirtyById: (state, action: PayloadAction<string>) => {
      state[action.payload] = false;
    },
    resetPanelsPristine: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { setPanelPristineById, setPanelDirtyById, resetPanelsPristine } =
  panelsPristineSlice.actions;

export const panelsPristineReducer = panelsPristineSlice.reducer;
